import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, withKeys as _withKeys, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-419a8834"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-question__title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-question__title__asterisk" }, " *", -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["disabled", "placeholder", "aria-label", "aria-describedby", "aria-required", "aria-invalid"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M1 1L13.4845 14",
  stroke: "#7D7D7D",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.0006 1L1.51611 14",
  stroke: "#7D7D7D",
  "stroke-width": "2",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "tw-form-control__icon--right",
  width: "27",
  height: "32",
  viewBox: "0 0 27 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M25.0375 8.96819C25.6156 10.4367 25.9357 12.0322 25.9357 13.7092C25.9357 25.3125 13.4679 30.543 13.4679 30.543C13.4679 30.543 1.00001 25.3216 1.00001 13.7092C0.991118 6.69286 6.57586 1 13.459 1C16.616 1 19.5061 2.19659 21.7027 4.17277",
    stroke: "#1C613B",
    "stroke-width": "1.6",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.459 19.1934C16.509 19.1934 18.9815 16.673 18.9815 13.564C18.9815 10.4549 16.509 7.93457 13.459 7.93457C10.409 7.93457 7.93652 10.4549 7.93652 13.564C7.93652 16.673 10.409 19.1934 13.459 19.1934Z",
    stroke: "#1C613B",
    "stroke-width": "1.6",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "checkbox__group" }
const _hoisted_11 = { class: "checkbox__item" }
const _hoisted_12 = ["id", "name", "checked"]
const _hoisted_13 = ["for"]
const _hoisted_14 = ["disabled", "aria-describedby", "placeholder", "aria-label", "aria-required", "aria-invalid"]
const _hoisted_15 = ["id"]

import { computed, onMounted, ref, watch } from 'vue'
import { InterviewQuestionResponseModel } from '@/models/QuestionModels'
import { useInterviewStore } from '@/stores/interviewStore'
import FlatButton from '@/components/Shared/FlatButton.vue'
import LocationPicker, { LocationPickerDataType } from '@/components/Shared/LocationPicker.vue'
import { useDialog } from '@/stores/dialogStore'
import { scrollToElementBottom } from '../scrollToElementBottom'

enum AnswerMode {
    dialog = 'dialog',
    freeText = 'freeText',
}



export default /*#__PURE__*/_defineComponent({
  __name: 'LocationQuestion',
  props: {
    question: null
  },
  emits: ['handleAnswerChoose'],
  setup(__props: any, { emit: emits }) {

const props = __props as { question: InterviewQuestionResponseModel };

const answerMode = ref<AnswerMode>(AnswerMode.dialog)
const pickerAnswer = ref<string>('')
const freeTextAnswer = ref<string>('')
const isSubmited = ref<boolean>(false)
const dialogStore = useDialog()



const touched = ref(false);

const interviewStore = useInterviewStore()
const pickerButtonText = interviewStore.getLocalization('InterviewQuestionary.LocationQuestion.PickerButton')
const rawInputCheckboxText = interviewStore.getLocalization('InterviewQuestionary.LocationQuestion.RawInputCheckbox')
const inputPlaceholder = interviewStore.getLocalization('InterviewQuestionary.LocationQuestion.InputPlaceholder')

const nextBtnText = computed(() => interviewStore.getLocalization('InterviewQuestionary.Common.NextQuestionButton'))
const errorMessage = computed(() => interviewStore.questionsAnswerError[props.question.Id])
const isSubmitable = computed(() => {
    validateField()
    return (answerMode.value === AnswerMode.dialog && !!pickerAnswer.value) || (answerMode.value === AnswerMode.freeText && !!freeTextAnswer.value)
})

const gmapKey = computed(() => interviewStore.googleMapKey)

function toggleAnswerMode(): void {
    answerMode.value = answerMode.value === AnswerMode.freeText ? AnswerMode.dialog : AnswerMode.freeText

    if (answerMode.value === AnswerMode.dialog) {
        chooseAnswer(pickerAnswer.value)
        interviewStore.changeAutomaticTag(props.question.Id, true)
    } else {
        chooseAnswer(freeTextAnswer.value)
        interviewStore.changeAutomaticTag(props.question.Id, false)
    }
}

const root = ref<HTMLElement | undefined>(undefined)
onMounted(() => scrollToElementBottom(root!.value as HTMLElement))

function showPicker() {
    dialogStore
        .open<LocationPickerDataType, string>(LocationPicker, {
            mapId: '361976e16d9326d2',
            zoom: 13,
            googleApiKey: gmapKey.value,
            askCurrentGeo: false
        })
        .then((address) => {
            if (!address) {
                return
            }
            
            pickerAnswer.value = address
            emits('handleAnswerChoose', address)
        })
}

function submitQuestion() {
    if (!isSubmitable.value || (interviewStore.isLastQuestion && interviewStore.checkError())) {
        return
    }

    interviewStore.nextQuestion()
    isSubmited.value = true
}

function pushAnswer(ans: string | null) {
    if (ans && ans?.length > 0) {
        interviewStore.changeAnswer(props.question.Id, ans)
    }
}

function validateField() {
    if(!(answerMode.value === AnswerMode.dialog && !!pickerAnswer.value) && !(answerMode.value === AnswerMode.freeText && !!freeTextAnswer.value) && touched.value)
    {
        interviewStore.questionsAnswerError[props.question.Id] = answerMode.value === AnswerMode.dialog ?
            interviewStore.getLocalization('Accessability.InterviewQuestionary.LocationField.EmptyPicker') :
            interviewStore.getLocalization('Accessability.InterviewQuestionary.LocationField.EmptyFreeText')
    }
    else
    {
        interviewStore.questionsAnswerError[props.question.Id] = null
    }
}

function chooseAnswer(newValue: string): void {
    emits('handleAnswerChoose', newValue)
    pushAnswer(newValue)
}

const onClearSelectedPlaceClick = () => {
    pickerAnswer.value = ''
}

watch(pickerAnswer, (newValue) => chooseAnswer(newValue))
watch(freeTextAnswer, (newValue) => chooseAnswer(newValue))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "tw-question"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.question.Title), 1),
      _hoisted_2
    ]),
    (!!__props.question.Description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "location-question-desc",
          innerHTML: __props.question.Description,
          class: "tw-question__description"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-form-control tw-form-control__with-icon--right", { 'pointer-none tw-form-control--disabled': answerMode.value === AnswerMode.freeText }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (showPicker())),
      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (showPicker()), ["enter"]))
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pickerAnswer).value = $event)),
        disabled: answerMode.value === AnswerMode.freeText,
        type: "text",
        placeholder: _unref(pickerButtonText),
        "aria-label": _unref(pickerButtonText),
        "aria-describedby": (_unref(errorMessage) && answerMode.value === AnswerMode.dialog) ? 'location-question-error-' + __props.question.Id : 'location-question-desc',
        "aria-required": answerMode.value === AnswerMode.dialog,
        "aria-invalid": answerMode.value === AnswerMode.dialog && !_unref(isSubmitable),
        class: _normalizeClass(["tw-form-control__input pointer-events-none", {
                    'tw-form-control__field-error--highlight': answerMode.value === AnswerMode.dialog && !_unref(isSubmitable) && touched.value,
                }])
      }, null, 10, _hoisted_4), [
        [_vModelText, pickerAnswer.value]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("svg", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onClearSelectedPlaceClick()), ["stop"])),
        class: "tw-form-control__icon--left clear-filed",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_7, 512)), [
        [_vShow, pickerAnswer.value]
      ]),
      _hoisted_8
    ], 34),
    (_unref(errorMessage) && answerMode.value === AnswerMode.dialog)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          id: 'location-question-error-' + __props.question.Id,
          role: "alert",
          "aria-live": "polite",
          style: {"color":"red","text-align":"center"}
        }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_9))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("input", {
          class: "checkbox__input",
          type: "checkbox",
          id: 'ch' + __props.question.Id,
          name: 'ch' + __props.question.Id,
          checked: answerMode.value === AnswerMode.freeText,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (toggleAnswerMode()))
        }, null, 40, _hoisted_12),
        _createElementVNode("label", {
          for: 'ch' + __props.question.Id,
          class: "checkbox__label"
        }, _toDisplayString(_unref(rawInputCheckboxText)), 9, _hoisted_13)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-form-control", { 'tw-form-control--disabled': answerMode.value === AnswerMode.dialog }])
    }, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((freeTextAnswer).value = $event)),
        disabled: answerMode.value === AnswerMode.dialog,
        "aria-describedby": (_unref(errorMessage) && answerMode.value !== AnswerMode.dialog) ? 'location-free-question-error-' + __props.question.Id : 'location-question-desc',
        placeholder: __props.question.Label ?? _unref(inputPlaceholder),
        "aria-label": __props.question.Label,
        rows: 1,
        onBlur: _cache[6] || (_cache[6] = ($event: any) => (touched.value = true)),
        "aria-required": answerMode.value === AnswerMode.freeText,
        "aria-invalid": answerMode.value === AnswerMode.freeText && touched.value && !_unref(isSubmitable),
        class: _normalizeClass({
                'tw-form-control__field-error--highlight': answerMode.value === AnswerMode.freeText && touched.value && !_unref(isSubmitable),
                'tw-form-control__textarea--error': answerMode.value === AnswerMode.freeText && touched.value && !_unref(isSubmitable),
                'tw-form-control__textarea tw-form-control__textarea--no-resize': true
                })
      }, null, 42, _hoisted_14), [
        [_vModelText, freeTextAnswer.value]
      ])
    ], 2),
    (_unref(errorMessage) && answerMode.value !== AnswerMode.dialog)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "tw-question__error",
          id: 'location-free-question-error-' + __props.question.Id,
          role: "alert",
          "aria-live": "polite"
        }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_15))
      : _createCommentVNode("", true),
    (_unref(isSubmitable) && !isSubmited.value)
      ? (_openBlock(), _createBlock(FlatButton, {
          key: 3,
          onClick: submitQuestion,
          modelValue: _unref(nextBtnText),
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(nextBtnText) ? (nextBtnText).value = $event : null)),
          bgColor: '#2C267A',
          isArrowStyle: true
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})